// @ts-nocheck
import React, { useEffect, useState } from "react";
import DashboardLayout from "../../components/layoutContainers/dashboardLayout";
import SoftBox from "../../components/common/softBox";
import {
  Card,
  FormControl,
  Select,
  MenuItem,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Table,
  Dialog,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import SoftTypography from "../../components/common/softTypography";
import CustomTable from "../../components/tables/table";
import { useNavigate } from "react-router-dom";
import DashboardNavbar from "../../components/navbars/dashboardNavbar";
import { useAppDispatch, useAppSelector } from "../../Hooks";
import {
  getOrderRequestsData,
  postOrderToSap,
  updateOrderRequestDetailData,
} from "../../features/orderRequests";
import SoftBadge from "../../components/common/softBadge";
import { toast } from "react-toastify";
import { prepareOrderData } from "../../utils/commonHelper";
import SoftButton from "../../components/common/softButton";
import SoftInput from "../../components/common/softInput";
import ActionMenu from "../../components/common/custom/action-menu";
import {
  getSapOrderConfig,
  getSapPlantStorage,
} from "../../features/sapConfig";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

const OrderRequests = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [update, setUpdate] = useState(false);
  const [data, setData] = useState([]);
  const [orderType, setOrderType] = useState("all");

  const { data: orderData, status } = useAppSelector(
    (state: any) => state.orderRequests
  );
  const { sapOrderConfigData, plantStorageData } = useAppSelector(
    (state: any) => state.sapConfig
  );
  const [totalRows, setTotalRows] = useState(0);
  const [pageIndex, setPageIndex] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const [openModal, setOpenModal] = useState(false);
  const [selectedOrderDetails, setSelectedOrderDetails] = useState([]);
  const [salesOrg, setSalesOrg] = useState({
    value: "",
    label: "",
  });
  const [selectedSalesOrg, setSelectedSalesOrg] = useState("");
  const [distChannel, setDistChannel] = useState("");
  const [selectedDistChannel, setSelectedDistChannel] = useState("");
  const [division, setDivision] = useState("");
  const [selectedDivision, setSelectedDivision] = useState("");

  useEffect(() => {
    if (openModal) {
      dispatch(
        getSapOrderConfig({
          filter: `BusPartner eq '${selectedOrderDetails?.BusPartner}' and CompCode eq '${selectedOrderDetails?.CompanyCode}'`,
        })
      );
      dispatch(
        getSapPlantStorage({
          filter: `CompanyCode eq '${selectedOrderDetails?.CompanyCode}'`,
        })
      );
    }
  }, [dispatch, openModal]);

  useEffect(() => {
    if (sapOrderConfigData && sapOrderConfigData.length > 0) {
      setSelectedSalesOrg(sapOrderConfigData[0].SalesOrg);

      const distChannelTemp = Array.from(
        new Set(
          sapOrderConfigData
            .filter((i) => i.SalesOrg === sapOrderConfigData[0].SalesOrg)
            .map((i) => i.DistChannel)
        )
      ).map((dc) => ({ value: dc, label: dc }));
      setSelectedDistChannel(distChannelTemp[0].value);
      setDistChannel(distChannelTemp);

      const divisionTemp = Array.from(
        new Set(
          sapOrderConfigData
            .filter(
              (i) =>
                i.SalesOrg === sapOrderConfigData[0].SalesOrg &&
                i.DistChannel === distChannelTemp[0].value
            )
            .map((i) => ({ value: i.Division, label: i.Division }))
        )
      );
      setSelectedDivision(divisionTemp[0].value);
      setSelectedOrderDetails({
        ...selectedOrderDetails,
        Division: divisionTemp[0].value,
        SalesOrg: distChannelTemp[0].value,
        DistChannel: distChannelTemp[0].value,
      });
      setDivision(divisionTemp);

      const uniqueSalesOrgs = Array.from(
        new Set(sapOrderConfigData.map((item) => item.SalesOrg))
      );
      const options = uniqueSalesOrgs.map((org) => ({
        value: org,
        label: org,
      }));
      setSalesOrg(options);
    }
  }, [sapOrderConfigData]);

  useEffect(() => {
    if (!selectedSalesOrg) return;

    const distChannelTemp = Array.from(
      new Set(
        sapOrderConfigData
          .filter((i) => i.SalesOrg === selectedSalesOrg)
          .map((i) => i.DistChannel)
      )
    ).map((dc) => ({ value: dc, label: dc }));

    setDistChannel(distChannelTemp);
  }, [selectedSalesOrg, sapOrderConfigData]);

  useEffect(() => {
    if (selectedDistChannel) {
      const divisionTemp = Array.from(
        new Set(
          sapOrderConfigData
            .filter(
              (i) =>
                i.SalesOrg === selectedSalesOrg &&
                i.DistChannel === selectedDistChannel
            )
            .map((i) => ({ value: i.Division, label: i.Division }))
        )
      );
      setDivision(divisionTemp);
    }
  }, [selectedDistChannel]);

  const columns = [
    {
      header: "ID",
      accessorKey: "id",
      id: "id",
      align: "center",
      cell: (info: any) => <span>{info.getValue()}</span>,
    },
    {
      header: "Name",
      accessorKey: "user_id",
      id: "owner_name",
      align: "left",
      cell: (info: any) => (
        <strong style={{ whiteSpace: "nowrap" }}>
          {info.getValue()?.owner_name || ""}
        </strong>
      ),
    },
    {
      header: "Business Partner",
      accessorKey: "BusPartner",
      id: "BusPartner",
      align: "left",
      cell: (info: any) => <span>{info.getValue()}</span>,
    },
    {
      header: "Sale Order Requesition No",
      accessorKey: "SalesOrderRequisition",
      id: "SalesOrderRequisition",
      align: "left",
      cell: (info: any) => <span>{info.getValue()}</span>,
    },
    {
      header: "Sale Order No",
      accessorKey: "SalesOrder",
      id: "SalesOrder",
      align: "left",
      cell: (info: any) => <span>{info.getValue()}</span>,
    },
    {
      header: "Dist Channel",
      accessorKey: "DistChannel",
      id: "DistChannel",
      align: "left",
      cell: (info: any) => <span>{info.getValue()}</span>,
    },
    {
      header: "Division",
      accessorKey: "Division",
      id: "Division",
      align: "left",
      cell: (info: any) => <span>{info.getValue()}</span>,
    },
    {
      header: "Order Type",
      accessorKey: "OrderType",
      id: "OrderType",
      align: "left",
      cell: (info: any) => <span>{info.getValue()}</span>,
    },
    {
      header: "Status",
      accessorKey: "status",
      id: "status",
      align: "left",
      cell: (info: any) => (
        <SoftBadge
          variant="gradient"
          badgeContent={info.getValue()}
          style={{ textTransform: "capitalize", fontWeight: "500" }}
          color={
            info.getValue() === "pending"
              ? "info"
              : info.getValue() === "reject"
              ? "error"
              : info.getValue() === "cancelled"
              ? "error"
              : info.getValue() === "ordered"
              ? "secondary"
              : "success"
          }
          size="xs"
          container
        />
      ),
    },
    {
      header: "Actions",
      id: "actions",
      align: "center",
      cell: (info: any) => {
        const detail = info.row.original;
        const id = detail._id;
        const status = detail.status;

        if (status === "cancelled") return null;

        return (
          <div>
            <ActionMenu sx={{ width: "50px" }}>
              {status !== "ordered" && (
                <MenuItem
                  onClick={() => {
                    setSelectedOrderDetails(detail);
                    setOpenModal(true);
                    // Optionally dispatch update
                  }}
                >
                  Add To SAP
                </MenuItem>
              )}

              {/* {status !== "approve" && (
                <MenuItem
                  onClick={() => {
                    dispatch(
                      updateOrderRequestDetailData({
                        id,
                        data: { status: "approve" },
                      })
                    );
                    setUpdate((prev) => !prev);
                  }}
                >
                  Approve
                </MenuItem>
              )}
              {(status === "pending" || status === "approve") && (
                <MenuItem
                  onClick={() => {
                    dispatch(
                      updateOrderRequestDetailData({
                        id,
                        data: { status: "reject" },
                      })
                    );
                    setUpdate((prev) => !prev);
                  }}
                >
                  Reject
                </MenuItem>
              )} */}
              <MenuItem onClick={() => navigate(`/order/view/${id}`)}>
                View
              </MenuItem>
            </ActionMenu>
          </div>
        );
      },
    },
  ];

  useEffect(() => {
    dispatch(getOrderRequestsData({ page: pageIndex, limit: pageSize }));
  }, [dispatch, pageIndex, pageSize, update]);

  useEffect(() => {
    if (status && orderData) {
      setData(orderData?.orders);
      setTotalRows(orderData?.total || 0);
    }
  }, [status, orderData]);

  const onFilterChange = (e) => {
    setOrderType(e.target.value);
    setPageIndex(1);
    setPageSize(10);
    dispatch(
      getOrderRequestsData({
        page: 1,
        limit: 10,
        status: e.target.value,
      })
    );
  };

  const submitOrderToSap = (data) => {
    const finalData = prepareOrderData(data);
    dispatch(
      postOrderToSap({ data: finalData, id: selectedOrderDetails?._id })
    ).then((res) => {
      if (res && res.payload && res.payload.status) {
        setOpenModal(false);
        dispatch(getOrderRequestsData({ page: pageIndex, limit: pageSize }));
        toast.success(res.payload.message);
      }
    });
  };

  const handlereject = () => {
    dispatch(
      updateOrderRequestDetailData({
        id: selectedOrderDetails?._id,
        data: { status: "reject" },
      })
    ).then((res) => {
      if (res && res.payload && res.payload.status) {
        dispatch(getOrderRequestsData({ page: pageIndex, limit: pageSize }));
        setUpdate(!update);
        toast.success(res.payload.message);
        setOpenModal(false);
      }
    });
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox mb={3} py={3}>
        <Card>
          <SoftBox
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            px={3}
            pt={3}
            pb={2}
          >
            <SoftTypography variant="h4" fontWeight="bold" textAlign="left">
              Order Requests
            </SoftTypography>
            <FormControl
              sx={{
                display: "flex",
                alignItems: "center",
                flexDirection: "row",
                whiteSpace: "nowrap",
                minWidth: "250px",
              }}
            >
              <SoftTypography
                sx={{
                  fontSize: "14px",
                  fontWeight: 500,
                  marginRight: "5px",
                }}
              >
                Order Status:
              </SoftTypography>
              <Select
                id="demo-simple-select"
                name="status"
                value={orderType}
                onChange={onFilterChange}
                IconComponent={KeyboardArrowDownIcon}
                fullWidth
                size="small"
                sx={{
                  padding: "0px 8px !important",
                  height: "40px !important",
                  display: "block !important",
                  ".MuiSelect-select": {
                    padding: "0px 8px !important",
                    height: "40px !important",
                  },
                  ".MuiSelect-nativeInput": {
                    height: "40px !important",
                  },
                  ".css-1e270hg-MuiSvgIcon-root-MuiSelect-icon": {
                    display: "block !important",
                    fontSize: "1.25rem !important",
                  },
                  ".css-8kuacp-MuiSvgIcon-root-MuiSelect-icon": {
                    display: "block !important",
                    fontSize: "1.25rem !important",
                  },
                }}
              >
                <MenuItem value={"all"} sx={{ marginBottom: "5px" }}>
                  All
                </MenuItem>
                <MenuItem value={"pending"} sx={{ marginBottom: "5px" }}>
                  Pending
                </MenuItem>
                <MenuItem value={"approve"} sx={{ marginBottom: "5px" }}>
                  Approved
                </MenuItem>
                <MenuItem value={"ordered"} sx={{ marginBottom: "5px" }}>
                  Ordered
                </MenuItem>
                <MenuItem value={"reject"} sx={{ marginBottom: "5px" }}>
                  Reject
                </MenuItem>
              </Select>
            </FormControl>
          </SoftBox>

          <SoftBox>
            <CustomTable
              columns={columns}
              data={data}
              pageIndex={pageIndex}
              pageSize={pageSize}
              totalRows={totalRows}
              onPageChange={(newPageIndex) => setPageIndex(newPageIndex)}
              onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
            />
          </SoftBox>
        </Card>
      </SoftBox>

      <Dialog
        open={openModal}
        onClose={() => setOpenModal(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle
          id="modal-modal-title"
          sx={{ fontSize: "18px", fontWeight: "700", lineHeight: "normal" }}
        >
          Post Order Request to SAP
        </DialogTitle>
        <DialogContent dividers>
          <SoftBox
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
            pb={2}
          >
            <SoftBox
              sx={{
                display: "flex",
                alignItems: "center",
                paddingBottom: "10px",
                marginBottom: "0px",
                borderBottom: "1px solid #ccc",
                borderRadius: "0px",
                width: {
                  sm: "100%",
                  md: "48%",
                },
              }}
            >
              <SoftTypography
                variant="button"
                fontWeight="bold"
                textTransform="capitalize"
              >
                Business Partner No: &nbsp;
              </SoftTypography>
              <SoftTypography
                variant="button"
                fontWeight="regular"
                color="text"
              >
                {selectedOrderDetails?.BusPartner || "N/A"}
              </SoftTypography>
            </SoftBox>
            <SoftBox
              sx={{
                display: "flex",
                alignItems: "center",
                paddingBottom: "10px",
                marginBottom: "0px",
                borderBottom: "1px solid #ccc",
                borderRadius: "0px",
                width: {
                  sm: "100%",
                  md: "48%",
                },
              }}
            >
              <SoftTypography
                variant="button"
                tag="h3"
                fontWeight="bold"
                textTransform="capitalize"
              >
                Name: &nbsp;
              </SoftTypography>
              <SoftTypography
                variant="button"
                fontWeight="regular"
                color="text"
              >
                &nbsp;{selectedOrderDetails?.user_id?.owner_name || "N/A"}
              </SoftTypography>
            </SoftBox>
          </SoftBox>
          <SoftBox
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
            pb={0}
          >
            <SoftBox
              sx={{
                display: "flex",
                alignItems: "center",
                paddingBottom: "10px",
                marginBottom: "0px",
                borderBottom: "1px solid #ccc",
                borderRadius: "0px",
                width: {
                  sm: "100%",
                  md: "48%",
                },
              }}
            >
              <SoftTypography
                variant="button"
                fontWeight="bold"
                textTransform="capitalize"
              >
                Status: &nbsp;
              </SoftTypography>
              <SoftBadge
                variant="gradient"
                badgeContent={selectedOrderDetails?.status}
                color={
                  selectedOrderDetails?.status === "pending"
                    ? "info"
                    : selectedOrderDetails?.status === "reject"
                    ? "error"
                    : "success"
                }
                size="xs"
                container
              />
            </SoftBox>
            <SoftBox
              sx={{
                display: "flex",
                alignItems: "center",
                paddingBottom: "10px",
                marginBottom: "0px",
                borderBottom: "1px solid #ccc",
                borderRadius: "0px",
                width: {
                  sm: "100%",
                  md: "48%",
                },
              }}
            >
              <SoftTypography
                variant="button"
                fontWeight="bold"
                textTransform="capitalize"
              >
                Order Type: &nbsp;
              </SoftTypography>
              <SoftTypography
                variant="button"
                fontWeight="regular"
                color="text"
              >
                {selectedOrderDetails?.OrderType || "N/A"}
              </SoftTypography>
            </SoftBox>
          </SoftBox>
          <SoftBox
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
            pb={0}
          >
            <SoftBox
              sx={{
                width: {
                  sm: "100%",
                  md: "48%",
                },
              }}
            >
              <SoftTypography
                variant="button"
                fontWeight="bold"
                textTransform="capitalize"
              >
                Sale Organization: &nbsp;
              </SoftTypography>
              <Select
                id="demo-simple-select"
                name="SalesOrg"
                value={selectedSalesOrg}
                onChange={(e) => {
                  setSelectedSalesOrg(e.target.value);
                  setSelectedOrderDetails({
                    ...selectedOrderDetails,
                    SalesOrg: e.target.value,
                  });
                }}
                IconComponent={KeyboardArrowDownIcon}
                fullWidth
                size="small"
                sx={{
                  padding: "0px 8px !important",
                  height: "40px !important",
                  display: "block !important",
                  ".MuiSelect-select": {
                    padding: "0px 8px !important",
                    height: "40px !important",
                  },
                  ".MuiSelect-nativeInput": {
                    height: "40px !important",
                  },
                  ".css-1e270hg-MuiSvgIcon-root-MuiSelect-icon": {
                    display: "block !important",
                    fontSize: "1.25rem !important",
                  },
                  ".css-8kuacp-MuiSvgIcon-root-MuiSelect-icon": {
                    display: "block !important",
                    fontSize: "1.25rem !important",
                  },
                }}
              >
                {salesOrg &&
                  salesOrg.length > 0 &&
                  salesOrg.map((item: any) => {
                    return <MenuItem value={item.value}>{item.label}</MenuItem>;
                  })}
              </Select>
            </SoftBox>
            <SoftBox
              sx={{
                width: {
                  sm: "100%",
                  md: "48%",
                },
              }}
            >
              <SoftTypography
                variant="button"
                fontWeight="bold"
                textTransform="capitalize"
              >
                Dist. Channel: &nbsp;
              </SoftTypography>
              <Select
                value={selectedDistChannel}
                onChange={(e) => {
                  setSelectedDistChannel(e.target.value);
                  setSelectedOrderDetails({
                    ...selectedOrderDetails,
                    DistChannel: e.target.value,
                  });
                }}
                id="demo-simple-select"
                name="distChannel"
                IconComponent={KeyboardArrowDownIcon}
                fullWidth
                size="small"
                sx={{
                  padding: "0px 8px !important",
                  height: "40px !important",
                  display: "block !important",
                  ".MuiSelect-select": {
                    padding: "0px 8px !important",
                    height: "40px !important",
                  },
                  ".MuiSelect-nativeInput": {
                    height: "40px !important",
                  },
                  ".css-1e270hg-MuiSvgIcon-root-MuiSelect-icon": {
                    display: "block !important",
                    fontSize: "1.25rem !important",
                  },
                  ".css-8kuacp-MuiSvgIcon-root-MuiSelect-icon": {
                    display: "block !important",
                    fontSize: "1.25rem !important",
                  },
                }}
              >
                {distChannel &&
                  distChannel.map((item: any, index: number) => (
                    <MenuItem value={item.value}>{item.label}</MenuItem>
                  ))}
              </Select>
            </SoftBox>
          </SoftBox>
          <SoftBox
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
            pb={0}
          >
            <SoftBox
              sx={{
                width: {
                  sm: "100%",
                  md: "100%",
                },
              }}
            >
              <SoftTypography
                variant="button"
                fontWeight="bold"
                textTransform="capitalize"
              >
                Division: &nbsp;
              </SoftTypography>
              <Select
                value={selectedDivision}
                onChange={(e) => {
                  setSelectedDivision(e.target.value);
                  setSelectedOrderDetails({
                    ...selectedOrderDetails,
                    Division: e.target.value,
                  });
                }}
                id="demo-simple-select"
                name="division"
                IconComponent={KeyboardArrowDownIcon}
                fullWidth
                size="small"
                sx={{
                  padding: "0px 8px !important",
                  height: "40px !important",
                  display: "block !important",
                  ".MuiSelect-select": {
                    padding: "0px 8px !important",
                    height: "40px !important",
                  },
                  ".MuiSelect-nativeInput": {
                    height: "40px !important",
                  },
                  ".css-1e270hg-MuiSvgIcon-root-MuiSelect-icon": {
                    display: "block !important",
                    fontSize: "1.25rem !important",
                  },
                  ".css-8kuacp-MuiSvgIcon-root-MuiSelect-icon": {
                    display: "block !important",
                    fontSize: "1.25rem !important",
                  },
                }}
              >
                {division &&
                  division.map((item: any, index: number) => (
                    <MenuItem value={item.value}>{item.label}</MenuItem>
                  ))}
              </Select>
            </SoftBox>
          </SoftBox>

          <SoftBox pb={2}>
            <SoftTypography
              variant="button"
              fontWeight="bold"
              textTransform="capitalize"
            >
              Material Details: &nbsp;
            </SoftTypography>
            <SoftBox display="div" pb={1} pr={2}>
              <TableContainer
                className="table-container"
                sx={{ padding: "0px", borderRadius: "0px" }}
              >
                <Table
                  className="w3-table-all"
                  sx={{ Width: "100%" }}
                  aria-label="Order Material List table"
                >
                  <TableHead>
                    <TableRow>
                      <TableCell>Item Number</TableCell>
                      <TableCell>Material No</TableCell>
                      <TableCell>Plant No</TableCell>
                      <TableCell>Target Quantity</TableCell>
                      <TableCell>Store Loc</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {selectedOrderDetails &&
                      selectedOrderDetails?.NavHeaderToItem &&
                      selectedOrderDetails?.NavHeaderToItem?.length > 0 &&
                      selectedOrderDetails?.NavHeaderToItem.map(
                        (item: any, index: number) => {
                          // Get all available plants
                          const availablePlants =
                            plantStorageData && plantStorageData.length > 0
                              ? Array.from(
                                  new Set(
                                    plantStorageData.map((ps: any) => ps.Plant)
                                  )
                                ).map((p) => ({ value: p, label: p }))
                              : [];

                          // Get available store locations for the selected plant in this row
                          const availableStorLocs =
                            plantStorageData && plantStorageData.length > 0
                              ? Array.from(
                                  new Set(
                                    plantStorageData
                                      .filter(
                                        (ps: any) => ps.Plant === item.Plant
                                      )
                                      .map((ps: any) => ps.StorLoc)
                                  )
                                ).map((sl) => ({ value: sl, label: sl }))
                              : [];

                          return (
                            <TableRow key={"order-item-" + index}>
                              <TableCell>{item.ItmNumber}</TableCell>
                              <TableCell>{item.Material}</TableCell>
                              <TableCell>
                                <Select
                                  value={item.Plant || ""}
                                  onChange={(e) => {
                                    const newPlant = e.target.value;
                                    // Find first storLoc for new plant
                                    const storLocsForPlant = plantStorageData
                                      ? plantStorageData
                                          .filter(
                                            (ps: any) => ps.Plant === newPlant
                                          )
                                          .map((ps: any) => ps.StorLoc)
                                      : [];
                                    const firstStorLoc =
                                      storLocsForPlant[0] || "";

                                    setSelectedOrderDetails({
                                      ...selectedOrderDetails,
                                      NavHeaderToItem:
                                        selectedOrderDetails.NavHeaderToItem.map(
                                          (itm: any, i: number) =>
                                            i === index
                                              ? {
                                                  ...itm,
                                                  Plant: newPlant,
                                                  StoreLoc: firstStorLoc, // reset store loc on plant change
                                                }
                                              : itm
                                        ),
                                    });
                                  }}
                                  id="plant-select"
                                  name="Plant"
                                  style={{ width: "100%" }}
                                >
                                  {availablePlants.map((p) => (
                                    <MenuItem key={p.value} value={p.value}>
                                      {p.label}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </TableCell>
                              <TableCell>
                                <SoftInput
                                  value={item.TargetQty}
                                  onChange={(e) =>
                                    setSelectedOrderDetails({
                                      ...selectedOrderDetails,
                                      NavHeaderToItem:
                                        selectedOrderDetails.NavHeaderToItem.map(
                                          (itm: any, i: number) =>
                                            i === index
                                              ? {
                                                  ...itm,
                                                  TargetQty: e.target.value,
                                                }
                                              : itm
                                        ),
                                    })
                                  }
                                />
                              </TableCell>
                              <TableCell>
                                <Select
                                  value={item.StoreLoc || ""}
                                  onChange={(e) => {
                                    setSelectedOrderDetails({
                                      ...selectedOrderDetails,
                                      NavHeaderToItem:
                                        selectedOrderDetails.NavHeaderToItem.map(
                                          (itm: any, i: number) =>
                                            i === index
                                              ? {
                                                  ...itm,
                                                  StoreLoc: e.target.value,
                                                }
                                              : itm
                                        ),
                                    });
                                  }}
                                  id="storloc-select"
                                  name="storLoc"
                                  style={{ width: "100%" }}
                                >
                                  {availableStorLocs.map((sl) => (
                                    <MenuItem key={sl.value} value={sl.value}>
                                      {sl.label}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </TableCell>
                            </TableRow>
                          );
                        }
                      )}
                  </TableBody>
                </Table>
              </TableContainer>
            </SoftBox>
          </SoftBox>

          <SoftBox pb={1} pr={2}>
            {selectedOrderDetails?.SalesOrder && (
              <p style={{ fontSize: 16, marginRight: "14px" }}>
                Your Order is Submited to Sap. Sales Order No:{" "}
                {selectedOrderDetails?.SalesOrder}
              </p>
            )}
          </SoftBox>
          <SoftBox
            display="flex"
            alignContent={"center"}
            justifyContent={"end"}
            py={1}
            pr={2}
          >
            <SoftButton
              className="modal_cancel modal_btn"
              onClick={handlereject}
              disabled={selectedOrderDetails?.status !== "pending"}
            >
              Reject
            </SoftButton>
            <SoftButton
              className="modal_btn"
              onClick={() => submitOrderToSap(selectedOrderDetails)}
              disabled={
                selectedOrderDetails?.SalesOrder ||
                selectedOrderDetails?.status !== "pending"
              }
            >
              Send To SAP
            </SoftButton>
          </SoftBox>
        </DialogContent>
      </Dialog>
    </DashboardLayout>
  );
};

export default OrderRequests;
